export default __webpack_public_path__ + "static/media/feature_3@3x.e68dd1fd.png";